import { render, staticRenderFns } from "./documentacionChangeCategoryModal.vue?vue&type=template&id=2a32f5be&scoped=true&"
import script from "./documentacionChangeCategoryModal.vue?vue&type=script&lang=js&"
export * from "./documentacionChangeCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./documentacionChangeCategoryModal.vue?vue&type=style&index=0&id=2a32f5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32f5be",
  null
  
)

export default component.exports